(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.LoginService = {}));
})(this, (function (exports) { 'use strict';

  function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
    return n;
  }
  function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
  }
  function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
      var i = n[a](c),
        u = i.value;
    } catch (n) {
      return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
  }
  function _asyncToGenerator(n) {
    return function () {
      var t = this,
        e = arguments;
      return new Promise(function (r, o) {
        var a = n.apply(t, e);
        function _next(n) {
          asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
        }
        function _throw(n) {
          asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
        }
        _next(void 0);
      });
    };
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
      var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;
      try {
        if (i = (t = t.call(r)).next, 0 === l) {
          if (Object(t) !== t) return;
          f = !1;
        } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
      } catch (r) {
        o = !0, n = r;
      } finally {
        try {
          if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
        } finally {
          if (o) throw n;
        }
      }
      return a;
    }
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
    var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
      var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
      return _regeneratorDefine(u, "_invoke", function (r, n, o) {
        var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
            p: 0,
            n: 0,
            v: e,
            a: d,
            f: d.bind(e, 4),
            d: function (t, r) {
              return i = t, c = 0, u = e, G.n = r, a;
            }
          };
        function d(r, n) {
          for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
            var o,
              i = p[t],
              d = G.p,
              l = i[2];
            r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
          }
          if (o || r > 1) return a;
          throw y = !0, n;
        }
        return function (o, p, l) {
          if (f > 1) throw TypeError("Generator is already running");
          for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
            i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
            try {
              if (f = 2, i) {
                if (c || (o = "next"), t = i[o]) {
                  if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                  if (!t.done) return t;
                  u = t.value, c < 2 && (c = 0);
                } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                i = e;
              } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
            } catch (t) {
              i = e, c = 1, u = t;
            } finally {
              f = 1;
            }
          }
          return {
            value: t,
            done: y
          };
        };
      }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
        return this;
      }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
      return this;
    }), _regeneratorDefine(u, "toString", function () {
      return "[object Generator]";
    }), (_regenerator = function () {
      return {
        w: i,
        m: f
      };
    })();
  }
  function _regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
      i({}, "", {});
    } catch (e) {
      i = 0;
    }
    _regeneratorDefine = function (e, r, n, t) {
      function o(r, n) {
        _regeneratorDefine(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      }
      r ? i ? i(e, r, {
        value: n,
        enumerable: !t,
        configurable: !t,
        writable: !t
      }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine(e, r, n, t);
  }
  function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _unsupportedIterableToArray(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
  }

  var environmentConfig = {
    production: {
      apiGatewayUrl: 'https://data.api.stv.tv/v2/',
      playerApiUrl: 'https://player.api.stv.tv/v1/',
      tractorbeamUrl: 'https://tractorbeam.stv.tv/',
      region: 'eu-west-1',
      userPoolId: 'eu-west-1_YJtAWaIgn',
      clientId: '3qf6kbka0bcvu1387nm0fq36s3',
      contentAPI: 'https://v4.api.stv.tv/v3/'
    },
    staging: {
      apiGatewayUrl: 'https://data.api.stvqa.tv/v2/',
      playerApiUrl: 'https://player.api.stvqa.tv/v1/',
      tractorbeamUrl: 'https://tractorbeam.stvqa.tv/',
      region: 'eu-west-1',
      userPoolId: 'eu-west-1_zxbSXLsBD',
      clientId: '6a4dbuf43mppsl588p4di9ot5t',
      contentAPI: 'https://v4.api.stvqa.tv/v3/'
    },
    development: {
      apiGatewayUrl: 'https://data.api.stvqa.tv/v2/',
      playerApiUrl: 'https://player.api.stvqa.tv/v1/',
      tractorbeamUrl: 'https://tractorbeam.stvqa.tv/',
      region: 'eu-west-1',
      userPoolId: 'eu-west-1_zxbSXLsBD',
      clientId: '6a4dbuf43mppsl588p4di9ot5t',
      contentAPI: 'https://v4.api.stvqa.tv/v3/'
    },
    testing: {
      apiGatewayUrl: 'http://localhost:3000/mockDataApi/',
      playerApiUrl: 'http://localhost:3000/mockPlayerApi/',
      tractorbeamUrl: 'https://localhost:3000/mockTractorbeamApi/',
      region: 'eu-west-1',
      userPoolId: 'eu-west-1_zxbSXLsBD',
      clientId: '6a4dbuf43mppsl588p4di9ot5t',
      contentAPI: 'https://v4.api.stvqa.tv/v3/'
    }
  };

  var _require$1 = require('qs'),
    parse = _require$1.parse;
  var getQueryString = function getQueryString() {
    return process.browser && parse(location.search);
  };
  var parseJson = function parseJson(json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      return undefined;
    }
  };

  var SUBSCRIPTION_TYPES = {
    PLUS: 'plus',
    SPORTS: 'premier_sports'
  };

  class InvalidTokenError extends Error {
  }
  InvalidTokenError.prototype.name = "InvalidTokenError";
  function b64DecodeUnicode(str) {
      return decodeURIComponent(atob(str).replace(/(.)/g, (m, p) => {
          let code = p.charCodeAt(0).toString(16).toUpperCase();
          if (code.length < 2) {
              code = "0" + code;
          }
          return "%" + code;
      }));
  }
  function base64UrlDecode(str) {
      let output = str.replace(/-/g, "+").replace(/_/g, "/");
      switch (output.length % 4) {
          case 0:
              break;
          case 2:
              output += "==";
              break;
          case 3:
              output += "=";
              break;
          default:
              throw new Error("base64 string is not of the correct length");
      }
      try {
          return b64DecodeUnicode(output);
      }
      catch (err) {
          return atob(output);
      }
  }
  function jwtDecode(token, options) {
      if (typeof token !== "string") {
          throw new InvalidTokenError("Invalid token specified: must be a string");
      }
      options || (options = {});
      const pos = options.header === true ? 0 : 1;
      const part = token.split(".")[pos];
      if (typeof part !== "string") {
          throw new InvalidTokenError(`Invalid token specified: missing part #${pos + 1}`);
      }
      let decoded;
      try {
          decoded = base64UrlDecode(part);
      }
      catch (e) {
          throw new InvalidTokenError(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
      }
      try {
          return JSON.parse(decoded);
      }
      catch (e) {
          throw new InvalidTokenError(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
      }
  }

  /*! js-cookie v3.0.5 | MIT */
  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (name, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      name = encodeURIComponent(name)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        name + '=' + converter.write(value, name) + stringifiedAttributes)
    }

    function get (name) {
      if (typeof document === 'undefined' || (arguments.length && !name)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var found = decodeURIComponent(parts[0]);
          jar[found] = converter.read(value, found);

          if (name === found) {
            break
          }
        } catch (e) {}
      }

      return name ? jar[name] : jar
    }

    return Object.create(
      {
        set,
        get,
        remove: function (name, attributes) {
          set(
            name,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });

  var _require = require('amazon-cognito-identity-js'),
    AuthenticationDetails = _require.AuthenticationDetails,
    CognitoUser = _require.CognitoUser,
    CookieStorage = _require.CookieStorage,
    CognitoUserPool = _require.CognitoUserPool,
    CognitoUserAttribute = _require.CognitoUserAttribute;
  var qs = require('qs');
  var defaultCookieExpires = 365;
  var groupTokenCookieExpires = 1;
  var setStvCookies = function setStvCookies(_ref) {
    var postcode = _ref.postcode,
      userId = _ref.userId,
      domain = _ref.domain,
      path = _ref.path,
      groupToken = _ref.groupToken,
      _ref$currentlySubscri = _ref.currentlySubscribed,
      currentlySubscribed = _ref$currentlySubscri === void 0 ? false : _ref$currentlySubscri,
      _ref$secure = _ref.secure,
      secure = _ref$secure === void 0 ? false : _ref$secure,
      playerPlus = _ref.playerPlus,
      userPersonalisationOptIn = _ref.userPersonalisationOptIn,
      vipOptIn = _ref.vipOptIn;
    api.set('STV_POSTCODE', postcode, {
      expires: defaultCookieExpires,
      domain: domain,
      secure: secure,
      path: path
    });
    api.set('STV_USERID', userId, {
      expires: defaultCookieExpires,
      domain: domain,
      secure: secure,
      path: path
    });
    api.set('STV_GROUPTOKEN', groupToken, {
      expires: groupTokenCookieExpires,
      domain: domain,
      secure: secure,
      path: path
    });
    currentlySubscribed && api.set('STV_AUTH_REQUIRED', 'true', {
      expires: defaultCookieExpires,
      domain: domain,
      secure: secure,
      path: path
    });
    api.set('STV_PERSONALISATION_OPTIN', userPersonalisationOptIn, {
      expires: defaultCookieExpires,
      domain: domain,
      secure: secure,
      path: path
    });
    api.set('STV_PLAYER_PLUS', JSON.stringify(playerPlus), {
      expires: defaultCookieExpires,
      domain: domain,
      secure: secure,
      path: path
    });
    api.set('STV_VIP_OPTIN', vipOptIn, {
      expires: defaultCookieExpires,
      domain: domain,
      secure: secure,
      path: path
    });
  };
  var removeStvCookies = function removeStvCookies(_ref2) {
    var domain = _ref2.domain,
      _ref2$path = _ref2.path,
      path = _ref2$path === void 0 ? '/' : _ref2$path;
    api.remove('STV_POSTCODE', {
      domain: domain,
      path: path
    });
    api.remove('STV_USERID', {
      domain: domain,
      path: path
    });
    api.remove('STV_GROUPTOKEN', {
      domain: domain,
      path: path
    });
    api.remove('STV_AUTH_REQUIRED', {
      domain: domain,
      path: path
    });
    api.remove('STV_PERSONALISATION_OPTIN', {
      domain: domain,
      path: path
    });
    api.remove('STV_PLAYER_PLUS', {
      domain: domain,
      path: path
    });
    api.remove('STV_VIP_OPTIN', {
      domain: domain,
      path: path
    });
  };
  var setTractorbeamTokens = function setTractorbeamTokens(_ref3) {
    var accessToken = _ref3.accessToken,
      refreshToken = _ref3.refreshToken,
      domain = _ref3.domain,
      secure = _ref3.secure,
      path = _ref3.path,
      expires = _ref3.expires;
    api.set('Tractorbeam_ACCESS_TOKEN', accessToken, {
      expires: expires,
      domain: domain,
      secure: secure,
      path: path
    });
    api.set('Tractorbeam_REFRESH_TOKEN', refreshToken, {
      expires: 30,
      domain: domain,
      secure: secure,
      path: path
    });
  };
  var LoginService = function LoginService(_ref4) {
    var currentDomain = _ref4.currentDomain,
      environment = _ref4.environment,
      isSecureProtocol = _ref4.isSecureProtocol,
      _ref4$platform = _ref4.platform,
      platform = _ref4$platform === void 0 ? 'desktop' : _ref4$platform;
    var poolData = {
      apiGatewayUrl: environmentConfig[environment].apiGatewayUrl,
      UserPoolId: environmentConfig[environment].userPoolId,
      ClientId: environmentConfig[environment].clientId,
      Storage: new CookieStorage({
        domain: ".".concat(currentDomain),
        secure: isSecureProtocol,
        expires: defaultCookieExpires
      })
    };
    var userPool = new CognitoUserPool(poolData);
    var checkKillswitch = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return fetch("".concat(environmentConfig[environment].playerApiUrl, "settings/webTractorbeamAuthEnabled"), {
                cache: 'no-cache',
                method: 'GET'
              });
            case 1:
              response = _context.v;
              _context.n = 2;
              return response.json();
            case 2:
              data = _context.v;
              return _context.a(2, data.results === '1');
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('Killswitch check failed, defaulting to v3:', _t);
              return _context.a(2, false);
          }
        }, _callee, null, [[0, 3]]);
      }));
      return function checkKillswitch() {
        return _ref5.apply(this, arguments);
      };
    }();
    var tractorbeamToken = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(cognitoAccessToken) {
        var response, tokenData, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return fetch("".concat(environmentConfig[environment].tractorbeamUrl, "oauth/token?groupToken=0071"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  grant_type: 'urn:ietf:params:oauth:grant-type:token-exchange',
                  subject_token_type: 'urn:ietf:params:oauth:token-type:access_token',
                  subject_token: cognitoAccessToken
                }),
                cache: 'no-cache'
              });
            case 1:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 2;
                break;
              }
              throw new Error("Token exchange failed: ".concat(response.status));
            case 2:
              _context2.n = 3;
              return response.json();
            case 3:
              tokenData = _context2.v;
              if (!(tokenData.access_token && tokenData.refresh_token)) {
                _context2.n = 4;
                break;
              }
              // Store v4 tokens in cookies
              setTractorbeamTokens({
                accessToken: tokenData.access_token,
                refreshToken: tokenData.refresh_token,
                domain: ".".concat(currentDomain),
                expires: tokenData.expires_in,
                secure: isSecureProtocol,
                path: '/'
              });
              return _context2.a(2, tokenData);
            case 4:
              throw new Error('Invalid token response');
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              console.error('V4 token exchange failed:', _t2);
              return _context2.a(2, null);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 5]]);
      }));
      return function tractorbeamToken(_x) {
        return _ref6.apply(this, arguments);
      };
    }();
    var fetchTractorbeamEntitlements = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(TractorbeamAccessToken) {
        var response, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return fetch("".concat(environmentConfig[environment].tractorbeamUrl, "viewer"), {
                cache: 'no-cache',
                method: 'GET',
                headers: {
                  Authorization: "Bearer ".concat(TractorbeamAccessToken)
                }
              });
            case 1:
              response = _context3.v;
              if (response.ok) {
                _context3.n = 2;
                break;
              }
              throw new Error("Tractorbeam entitlements fetch failed: ".concat(response.status));
            case 2:
              _context3.n = 3;
              return response.json();
            case 3:
              return _context3.a(2, _context3.v);
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              console.error('Tractorbeam entitlements fetch failed:', _t3);
              throw _t3;
            case 5:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 4]]);
      }));
      return function fetchTractorbeamEntitlements(_x2) {
        return _ref7.apply(this, arguments);
      };
    }();
    var fetchV3Entitlements = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(cognitoAccessToken) {
        var response, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return fetch("".concat(environmentConfig[environment].contentAPI, "cognito/viewer"), {
                cache: 'no-cache',
                method: 'GET',
                headers: {
                  Authorization: "Bearer ".concat(cognitoAccessToken)
                }
              });
            case 1:
              response = _context4.v;
              if (response.ok) {
                _context4.n = 2;
                break;
              }
              throw new Error("V3 entitlements fetch failed: ".concat(response.status));
            case 2:
              _context4.n = 3;
              return response.json();
            case 3:
              return _context4.a(2, _context4.v);
            case 4:
              _context4.p = 4;
              _t4 = _context4.v;
              console.error('V3 entitlements fetch failed:', _t4);
              throw _t4;
            case 5:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 4]]);
      }));
      return function fetchV3Entitlements(_x3) {
        return _ref8.apply(this, arguments);
      };
    }();
    var getGroupToken = function getGroupToken(_ref9) {
      var postcode = _ref9.postcode,
        userId = _ref9.userId;
      var gateway = environmentConfig[environment].playerApiUrl;
      var endpoint = 'grouptoken';
      var params = qs.stringify({
        postcode: postcode,
        gigyaId: userId,
        device: platform
      });
      return fetch("".concat(gateway).concat(endpoint, "?").concat(params), {
        cache: 'no-cache'
      }).then(function (response) {
        return response.json();
      }).then(function (responseJson) {
        if (responseJson.success && responseJson.results.grouptoken) {
          return responseJson.results.grouptoken;
        }
        throw new Error('Unable to fetch groupToken');
      });
    };
    var signInUser = function signInUser(_ref0) {
      var email = _ref0.email,
        password = _ref0.password;
      var authenticationDetails = new AuthenticationDetails({
        Username: email,
        Password: password
      });
      var userData = {
        Username: email,
        Pool: userPool,
        Storage: new CookieStorage({
          domain: ".".concat(currentDomain),
          secure: isSecureProtocol,
          expires: defaultCookieExpires
        })
      };
      var cognitoUser = new CognitoUser(userData);
      return authenticateUser({
        cognitoUser: cognitoUser,
        authenticationDetails: authenticationDetails,
        password: password
      }).then(getUserObject)["catch"](function (error) {
        logOut();
        throw new Error(error);
      });
    };
    var getVipOptIn = /*#__PURE__*/function () {
      var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(userId) {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              return _context5.a(2, fetch("".concat(poolData.apiGatewayUrl, "users/").concat(userId, "/newsletters"), {
                cache: 'no-cache'
              }).then(function (response) {
                return response.json();
              }).then(function (responseJson) {
                if (responseJson.success && typeof responseJson.results.STV_OptedInEmail !== 'undefined') {
                  return responseJson.results.STV_OptedInEmail;
                }
                throw new Error('Unable to fetch VIP status');
              }));
          }
        }, _callee5);
      }));
      return function getVipOptIn(_x4) {
        return _ref1.apply(this, arguments);
      };
    }();
    var authenticateUser = function authenticateUser(_ref10) {
      var cognitoUser = _ref10.cognitoUser,
        authenticationDetails = _ref10.authenticationDetails,
        password = _ref10.password;
      cognitoUser.setAuthenticationFlowType('USER_PASSWORD_AUTH');
      return new Promise(function (resolve, reject) {
        var onAuthSuccess = /*#__PURE__*/function () {
          var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(userSession) {
            var userObject, _ref12, _ref12$postal_code, postcode, userId, playerPlus, currentlySubscribed, userPersonalisationOptIn, vipPromise, gtPromise;
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.n) {
                case 0:
                  userObject = getUserObject(userSession);
                  _ref12 = parseJson(userObject.address.formatted) || {}, _ref12$postal_code = _ref12.postal_code, postcode = _ref12$postal_code === void 0 ? '' : _ref12$postal_code;
                  userId = userObject['cognito:username'];
                  _context6.n = 1;
                  return getSubscriptionInfo(true);
                case 1:
                  playerPlus = _context6.v;
                  currentlySubscribed = playerPlus.currentlySubscribed;
                  userPersonalisationOptIn = userObject['custom:personalised'] !== 'false';
                  vipPromise = getVipOptIn(userId);
                  gtPromise = getGroupToken({
                    postcode: postcode,
                    userId: userId
                  });
                  Promise.all([vipPromise, gtPromise]).then(function (_ref13) {
                    var _ref14 = _slicedToArray(_ref13, 2),
                      vipOptIn = _ref14[0],
                      groupToken = _ref14[1];
                    setStvCookies({
                      groupToken: groupToken,
                      postcode: postcode,
                      userId: userId,
                      currentlySubscribed: currentlySubscribed,
                      domain: ".".concat(currentDomain),
                      secure: isSecureProtocol,
                      userPersonalisationOptIn: userPersonalisationOptIn,
                      playerPlus: playerPlus,
                      vipOptIn: vipOptIn
                    });
                    resolve(userSession);
                  })["catch"](reject);
                case 2:
                  return _context6.a(2);
              }
            }, _callee6);
          }));
          return function onAuthSuccess(_x5) {
            return _ref11.apply(this, arguments);
          };
        }();
        var onFailure = function onFailure(error) {
          reject(JSON.stringify(error));
          // custom authentication
          cognitoUser.setAuthenticationFlowType('CUSTOM_AUTH');
          cognitoUser.initiateAuth(authenticationDetails, {
            onSuccess: function onSuccess() {
              changePassword(null, password, cognitoUser.email).then(onAuthSuccess)["catch"](reject);
            },
            onFailure: reject,
            customChallenge: function customChallenge() {
              cognitoUser.sendCustomChallengeAnswer(password, this);
            }
          });
        };
        cognitoUser.authenticateUser(authenticationDetails, {
          onSuccess: onAuthSuccess,
          onFailure: onFailure
        });
      });
    };
    var logOut = function logOut() {
      if (process.browser && window.gigya) {
        window.gigya.accounts.logout({
          callback: loggedOutHandler
        });
      } else {
        loggedOutHandler();
      }
    };
    var loggedOutHandler = function loggedOutHandler() {
      var user = userPool.getCurrentUser();
      if (user) {
        user.signOut();
        removeStvCookies({
          domain: ".".concat(currentDomain)
        });
      }
    };
    var getUser = function getUser() {
      var cognitoUser = getCognitoUserObject();
      if (cognitoUser) {
        return getUserSession(cognitoUser).then(function (session) {
          if (!session || !session.idToken || !session.idToken.jwtToken) {
            // If we're missing any crucial auth pieces, force logout and reload
            logOut();
            window.location.reload();
            return false;
          }
          return session.isValid() ? session : refreshUserSession({
            user: cognitoUser,
            session: session
          });
        }).then(function (session) {
          return getUserObject(session);
        })["catch"](function () {
          Promise.resolve(false);
        });
      }
      return Promise.resolve(false);
    };
    var getSubscriptionInfo = /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(isForceApi) {
        var defaults, user, _data$attributes, session, _session$accessToken, accessToken, subData, responseJson, authMethod, killswitchEnabled, tractorbeamTokens, _responseJson, data, groups, baseResponse, activeSubscription, _data$meta, response, expiredSubscription, _response;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              defaults = {
                cancelRequested: null,
                currentlySubscribed: false,
                expiry: null,
                isTrial: false,
                status: null,
                subscriptionMethod: null,
                subscriptionType: null,
                usedTrial: false
              };
              user = getCognitoUserObject();
              if (user) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, defaults);
            case 1:
              _context7.p = 1;
              _context7.n = 2;
              return getUserSession(user).then(function (sess) {
                return sess !== null && sess !== void 0 && sess.isValid() ? sess : refreshUserSession({
                  user: user,
                  session: sess
                });
              });
            case 2:
              session = _context7.v;
              try {
                // jwtDecode will throw an error if the token is invalid
                jwtDecode(session === null || session === void 0 || (_session$accessToken = session.accessToken) === null || _session$accessToken === void 0 ? void 0 : _session$accessToken.jwtToken, {
                  header: true
                });
              } catch (e) {
                // refreshUserSession
                refreshUserSession({
                  user: user,
                  session: session
                });
              }
              if (session) {
                _context7.n = 3;
                break;
              }
              throw new Error('Invalid session');
            case 3:
              accessToken = session.accessToken;
              subData = api.get('STV_PLAYER_PLUS');
              if (!(subData && !isForceApi)) {
                _context7.n = 4;
                break;
              }
              return _context7.a(2, JSON.parse(subData));
            case 4:
              authMethod = 'v3'; // track the auth method
              _context7.p = 5;
              _context7.n = 6;
              return checkKillswitch();
            case 6:
              killswitchEnabled = _context7.v;
              if (killswitchEnabled) {
                _context7.n = 8;
                break;
              }
              _context7.n = 7;
              return fetchV3Entitlements(accessToken === null || accessToken === void 0 ? void 0 : accessToken.jwtToken);
            case 7:
              responseJson = _context7.v;
              authMethod = 'v3-killswitch-disabled';
              _context7.n = 17;
              break;
            case 8:
              _context7.p = 8;
              _context7.n = 9;
              return tractorbeamToken(accessToken === null || accessToken === void 0 ? void 0 : accessToken.jwtToken);
            case 9:
              tractorbeamTokens = _context7.v;
              _context7.p = 10;
              _context7.n = 11;
              return fetchTractorbeamEntitlements(tractorbeamTokens.access_token);
            case 11:
              responseJson = _context7.v;
              authMethod = 'tractorbeam-killswitch-enabled';
              _context7.n = 14;
              break;
            case 12:
              _context7.p = 12;
              _context7.v;
              _context7.n = 13;
              return fetchV3Entitlements(accessToken === null || accessToken === void 0 ? void 0 : accessToken.jwtToken);
            case 13:
              responseJson = _context7.v;
              authMethod = 'v3-fallback-entitlements';
            case 14:
              _context7.n = 17;
              break;
            case 15:
              _context7.p = 15;
              _context7.v;
              _context7.n = 16;
              return fetchV3Entitlements(accessToken === null || accessToken === void 0 ? void 0 : accessToken.jwtToken);
            case 16:
              responseJson = _context7.v;
              authMethod = 'v3-fallback-exchange';
            case 17:
              _context7.n = 19;
              break;
            case 18:
              _context7.p = 18;
              _context7.v;
              return _context7.a(2, defaults);
            case 19:
              _responseJson = responseJson, data = _responseJson.data;
              groups = (data === null || data === void 0 || (_data$attributes = data.attributes) === null || _data$attributes === void 0 ? void 0 : _data$attributes.groups) || [];
              baseResponse = {
                currentlySubscribed: groups.find(function (group) {
                  var _group$name;
                  return Object.values(SUBSCRIPTION_TYPES).includes(group === null || group === void 0 || (_group$name = group.name) === null || _group$name === void 0 ? void 0 : _group$name.replace(/\s+/g, '_').toLowerCase()) && Date.parse(group === null || group === void 0 ? void 0 : group.end_date) > Date.now();
                }) ? true : false,
                authMethod: authMethod
              };
              if (!(groups.length > 0)) {
                _context7.n = 21;
                break;
              }
              activeSubscription = groups.find(function (group) {
                var _group$name2;
                return Object.values(SUBSCRIPTION_TYPES).includes(group === null || group === void 0 || (_group$name2 = group.name) === null || _group$name2 === void 0 ? void 0 : _group$name2.replace(/\s+/g, '_').toLowerCase()) && Date.parse(group === null || group === void 0 ? void 0 : group.end_date) > Date.now();
              });
              if (!activeSubscription) {
                _context7.n = 20;
                break;
              }
              response = _objectSpread2(_objectSpread2(_objectSpread2({}, defaults), baseResponse), {}, {
                subscriptionMethod: data === null || data === void 0 || (_data$meta = data.meta) === null || _data$meta === void 0 ? void 0 : _data$meta.billing_provider,
                subscriptionType: activeSubscription.name.toLowerCase(),
                expiry: activeSubscription.end_date,
                isTrial: activeSubscription.isTrial || false,
                usedTrial: (activeSubscription === null || activeSubscription === void 0 ? void 0 : activeSubscription.usedTrial) || true,
                renewalPeriod: activeSubscription.renewal_period,
                cancelRequested: activeSubscription.cancel_requested || null,
                status: (activeSubscription === null || activeSubscription === void 0 ? void 0 : activeSubscription.status) || 'active'
              });
              return _context7.a(2, response);
            case 20:
              expiredSubscription = groups.find(function (group) {
                var _group$name3;
                return Object.values(SUBSCRIPTION_TYPES).includes(group === null || group === void 0 || (_group$name3 = group.name) === null || _group$name3 === void 0 ? void 0 : _group$name3.replace(/\s+/g, '_').toLowerCase()) && Date.parse(group === null || group === void 0 ? void 0 : group.end_date) < Date.now();
              });
              _response = _objectSpread2(_objectSpread2(_objectSpread2({}, defaults), baseResponse), {}, {
                expiry: (expiredSubscription === null || expiredSubscription === void 0 ? void 0 : expiredSubscription.end_date) || null,
                usedTrial: (expiredSubscription === null || expiredSubscription === void 0 ? void 0 : expiredSubscription.usedTrial) || true,
                status: (expiredSubscription === null || expiredSubscription === void 0 ? void 0 : expiredSubscription.status) || null,
                currentlySubscribed: false
              });
              return _context7.a(2, _response);
            case 21:
              return _context7.a(2, defaults);
            case 22:
              _context7.p = 22;
              _context7.v;
              return _context7.a(2, defaults);
          }
        }, _callee7, null, [[10, 12], [8, 15], [5, 18], [1, 22]]);
      }));
      return function getSubscriptionInfo(_x6) {
        return _ref15.apply(this, arguments);
      };
    }();
    var updateUserDataMarketing = function updateUserDataMarketing(attributeList) {
      var cognitoUser = getCognitoUserObject();
      var newsLetters = attributeList;
      if (attributeList.Name === 'custom:newsletters') {
        newsLetters = JSON.parse(attributeList.Value);
      }
      return getUserSession(cognitoUser).then(function (userSession) {
        return fetch("".concat(poolData.apiGatewayUrl, "users"), {
          method: 'PUT',
          body: JSON.stringify({
            AccessToken: userSession.accessToken.jwtToken,
            Newsletters: newsLetters
          })
        }).then(function (response) {
          if (response.status === 200) {
            return userSession;
          }
          throw new Error();
        }).then(function (session) {
          return refreshUserSession({
            user: cognitoUser,
            session: session
          });
        });
      });
    };
    var getCognitoUserObject = function getCognitoUserObject() {
      return userPool.getCurrentUser();
    };
    var getUserSession = function getUserSession() {
      var cognitoUserObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCognitoUserObject();
      return new Promise(function (resolve, reject) {
        if (cognitoUserObject) {
          cognitoUserObject.getSession(function (err, session) {
            return resolve(session);
          });
        } else {
          reject();
        }
      });
    };
    var refreshUserSession = function refreshUserSession(_ref16) {
      var user = _ref16.user,
        session = _ref16.session;
      return new Promise(function (resolve, reject) {
        user.refreshSession(session.refreshToken, /*#__PURE__*/function () {
          var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(error, refreshedSession) {
            var userObject, _ref18, _ref18$postal_code, postcode, userId, playerPlus, currentlySubscribed, userPersonalisationOptIn, vipPromise, gtPromise;
            return _regenerator().w(function (_context8) {
              while (1) switch (_context8.n) {
                case 0:
                  if (!error) {
                    _context8.n = 1;
                    break;
                  }
                  reject(error);
                  return _context8.a(2);
                case 1:
                  userObject = getUserObject(refreshedSession);
                  _ref18 = parseJson(userObject.address.formatted) || {}, _ref18$postal_code = _ref18.postal_code, postcode = _ref18$postal_code === void 0 ? '' : _ref18$postal_code;
                  userId = userObject['cognito:username'];
                  _context8.n = 2;
                  return getSubscriptionInfo(true);
                case 2:
                  playerPlus = _context8.v;
                  currentlySubscribed = playerPlus.currentlySubscribed;
                  userPersonalisationOptIn = userObject['custom:personalised'] !== 'false';
                  vipPromise = getVipOptIn(userId);
                  gtPromise = getGroupToken({
                    postcode: postcode,
                    userId: userId
                  })["catch"](function (error) {
                    console.error(error);
                    var currentGroupToken = api.get('STV_GROUPTOKEN');
                    if (currentGroupToken) {
                      return currentGroupToken;
                    }
                    console.error('No groupToken found');
                    return null;
                  });
                  Promise.all([vipPromise, gtPromise]).then(function (_ref19) {
                    var _ref20 = _slicedToArray(_ref19, 2),
                      vipOptIn = _ref20[0],
                      groupToken = _ref20[1];
                    setStvCookies({
                      groupToken: groupToken,
                      postcode: postcode,
                      userId: userId,
                      currentlySubscribed: currentlySubscribed,
                      domain: ".".concat(currentDomain),
                      secure: isSecureProtocol,
                      userPersonalisationOptIn: userPersonalisationOptIn,
                      playerPlus: playerPlus,
                      vipOptIn: vipOptIn
                    });
                    resolve(refreshedSession);
                  });
                case 3:
                  return _context8.a(2);
              }
            }, _callee8);
          }));
          return function (_x7, _x8) {
            return _ref17.apply(this, arguments);
          };
        }());
      });
    };
    var getUserObject = function getUserObject() {
      var session = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUserSession();
      if (session) {
        var token = session.idToken && session.idToken.jwtToken;
        return token ? jwtDecode(token) : null;
      }
      return null;
    };
    var signUpUser = function signUpUser(_ref21) {
      var emailValue = _ref21.emailValue,
        firstNameValue = _ref21.firstNameValue,
        lastNameValue = _ref21.lastNameValue,
        dobValue = _ref21.dobValue,
        postcodeValue = _ref21.postcodeValue,
        passwordValue = _ref21.passwordValue,
        honorificValue = _ref21.honorificValue,
        _ref21$marketingValue = _ref21.marketingValue,
        marketingValue = _ref21$marketingValue === void 0 ? false : _ref21$marketingValue;
      var getRegSource = function getRegSource() {
        var _getQueryString = getQueryString(),
          siteAction = _getQueryString.siteAction,
          source = _getQueryString.source;
        return siteAction === 'remoteLogin' ? source : window.location.href;
      };
      var attributeList = [];
      var dataEmail = {
        Name: 'email',
        Value: emailValue
      };
      var dataFirstName = {
        Name: 'given_name',
        Value: firstNameValue
      };
      var dataLastName = {
        Name: 'family_name',
        Value: lastNameValue
      };
      var dataDOB = {
        Name: 'birthdate',
        Value: dobValue.split('/').reverse().join('-')
      };
      var dataPostcode = {
        Name: 'address',
        Value: JSON.stringify({
          postal_code: postcodeValue
        })
      };
      var dataMarketing = {
        STV_OptedInEmail: marketingValue
      };
      var dataHonorific = {
        Name: 'custom:honorific',
        Value: honorificValue
      };
      var dataRegSource = {
        Name: 'custom:registrationSource',
        Value: getRegSource()
      };
      var dataAdvertising = {
        Name: 'custom:targetedAdvertising',
        Value: 'true'
      };
      var dataPersonalised = {
        Name: 'custom:personalised',
        Value: 'true'
      };
      var attributeEmail = new CognitoUserAttribute(dataEmail);
      var attributeFirstName = new CognitoUserAttribute(dataFirstName);
      var attributeLastName = new CognitoUserAttribute(dataLastName);
      var attributeHonorific = new CognitoUserAttribute(dataHonorific);
      var attributeDOB = new CognitoUserAttribute(dataDOB);
      var attributePostcode = new CognitoUserAttribute(dataPostcode);
      var attributeRegSource = new CognitoUserAttribute(dataRegSource);
      var attributeAdvertising = new CognitoUserAttribute(dataAdvertising);
      var attributePersonalised = new CognitoUserAttribute(dataPersonalised);
      attributeList.push(attributeEmail, attributeFirstName, attributeLastName, attributeDOB, attributePostcode, attributeRegSource, attributeAdvertising, attributePersonalised, attributeHonorific);
      return fetch("".concat(poolData.apiGatewayUrl, "users"), {
        method: 'POST',
        body: JSON.stringify({
          Password: passwordValue,
          ClientId: poolData.ClientId,
          UserAttributes: attributeList,
          Newsletters: dataMarketing
        })
      }).then(function (response) {
        return response.json();
      }).then(function (response, error) {
        if (response && response.results.UserConfirmed) {
          return signInUser({
            email: emailValue.toLowerCase(),
            password: passwordValue
          });
        }
        throw new Error(error);
      });
    };
    var deleteUser = function deleteUser() {
      var cognitoUser = getCognitoUserObject();
      return getUserSession(cognitoUser).then(function (userSession) {
        return fetch("".concat(poolData.apiGatewayUrl, "users"), {
          method: 'DELETE',
          body: JSON.stringify({
            AccessToken: userSession.accessToken.jwtToken
          })
        }).then(function (response) {
          if (response.status === 200) {
            logOut();
            return true;
          }
          throw new Error();
        });
      });
    };
    var updateUser = function updateUser(changedAttributesObj) {
      var cognitoUser = getCognitoUserObject();
      return getUserSession(cognitoUser).then(function (userSession) {
        var attributeList = Object.keys(changedAttributesObj).map(function (key) {
          if (key === 'address') {
            return {
              Name: key,
              Value: JSON.stringify({
                postal_code: changedAttributesObj[key]
              })
            };
          }
          return {
            Name: key,
            Value: changedAttributesObj[key]
          };
        });
        return fetch("".concat(poolData.apiGatewayUrl, "users"), {
          method: 'PUT',
          body: JSON.stringify({
            AccessToken: userSession.accessToken.jwtToken,
            UserAttributes: attributeList
          })
        }).then(function (response) {
          if (response.status === 200) {
            return userSession;
          }
          throw new Error();
        });
      }).then(function (session) {
        return refreshUserSession({
          user: cognitoUser,
          session: session
        });
      });
    };
    var sendResetPasswordEmail = function sendResetPasswordEmail(email) {
      return new Promise(function (resolve, reject) {
        var cognitoUser = new CognitoUser({
          Username: email,
          Pool: userPool
        });
        cognitoUser.forgotPassword({
          onSuccess: function onSuccess() {
            resolve({
              cognitoUser: CognitoUser
            });
          },
          onFailure: reject
        });
      });
    };
    var changePassword = function changePassword(password, newPassword) {
      var cognitoUser = getCognitoUserObject();
      return getUserSession(cognitoUser).then(function (userSession) {
        var body = {
          AccessToken: userSession.accessToken.jwtToken,
          ProposedPassword: newPassword
        };
        if (password) {
          body.PreviousPassword = password;
        }
        return fetch("".concat(poolData.apiGatewayUrl, "users/password/"), {
          method: 'PUT',
          body: JSON.stringify(body)
        }).then(function (response) {
          if (response.status === 200) {
            return userSession;
          }
          throw new Error();
        }).then(function (session) {
          return refreshUserSession({
            user: cognitoUser,
            session: session
          });
        });
      });
    };
    var resetPassword = function resetPassword(username, password) {
      var _getQueryString2 = getQueryString(),
        code = _getQueryString2.code;
      if (!code) {
        throw new Error();
      }
      var newPassword = password;
      return fetch("".concat(poolData.apiGatewayUrl, "users/password/"), {
        method: 'PUT',
        body: JSON.stringify({
          ClientId: poolData.ClientId,
          Password: newPassword,
          ConfirmationCode: code,
          Username: username
        })
      }).then(function (response) {
        if (response.status === 200) {
          return;
        }
        throw new Error();
      });
    };
    return {
      signInUser: signInUser,
      logOut: logOut,
      getUser: getUser,
      getCognitoUserObject: getCognitoUserObject,
      getUserSession: getUserSession,
      refreshUserSession: refreshUserSession,
      signUpUser: signUpUser,
      deleteUser: deleteUser,
      updateUser: updateUser,
      sendResetPasswordEmail: sendResetPasswordEmail,
      changePassword: changePassword,
      resetPassword: resetPassword,
      apiGatewayUrl: poolData.apiGatewayUrl,
      updateUserDataMarketing: updateUserDataMarketing,
      getGroupToken: getGroupToken,
      getSubscriptionInfo: getSubscriptionInfo
    };
  };
  var clientId = function clientId(environment) {
    var id = environmentConfig[environment] && environmentConfig[environment].clientId;
    return id || environmentConfig['production'].clientId;
  };

  exports.clientId = clientId;
  exports["default"] = LoginService;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
